import React, { useEffect, useState } from "react";
import { IoIosArrowForward, IoMdNotifications } from "react-icons/io";
import { FaBars } from "react-icons/fa6";
import {
  MdOutlinePayment,
  MdOutlinePerson2,
  MdOutlinePersonAddAlt,
  MdStarBorderPurple500,
} from "react-icons/md";
import { GrUserSettings } from "react-icons/gr";
import { BsBoxSeamFill } from "react-icons/bs";
import { RiLockPasswordFill, RiLogoutBoxLine } from "react-icons/ri";
import { PiHeadCircuit } from "react-icons/pi";
import { CiUser } from "react-icons/ci";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { useAuth } from "../../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import { GoHomeFill } from "react-icons/go";
import { MdOutlineFace6 } from "react-icons/md";
import { USER_URL } from "../../../constant/api";
import { FaGear } from "react-icons/fa6";

const profilemenu = [
  {
    icon: <GoHomeFill fontSize={24} className="text-blue-600" />,
    title: "Home",
    desc: "Return to the main page.",
    bgColor: "bg-blue-100",
    path: "/",
  },
  {
    icon: <MdOutlineFace6 fontSize={24} className="text-purple-600" />,
    title: "View Profile",
    desc: "Profile.",
    bgColor: "bg-purple-100",
    path: "view",
  },
  {
    icon: <BsBoxSeamFill fontSize={24} className="text-green-600" />,
    title: "My Orders",
    desc: "View your orders.",
    bgColor: "bg-green-100",
    path: "/myorders",
  },
  {
    icon: <MdOutlinePayment fontSize={24} className="text-orange-600" />,
    title: "Payment",
    desc: "Transaction history.",
    bgColor: "bg-orange-100",
    path: "payments",
  },
  {
    icon: <GrUserSettings fontSize={22} className="text-teal-600" />,
    title: "Edit Profile",
    desc: "Update your profile details.",
    bgColor: "bg-teal-100",
    path: "edit_profile",
  },
  {
    icon: <RiLockPasswordFill fontSize={24} className="text-red-600" />,
    title: "Change Password",
    desc: "Change your password.",
    bgColor: "bg-red-100",
    path: "change_password",
  },
  {
    icon: <MdOutlinePersonAddAlt fontSize={24} className="text-indigo-600" />,
    title: "Add Address",
    desc: "Add or update your address.",
    bgColor: "bg-indigo-100",
    path: "add_address",
  },
  {
    icon: <IoMdNotifications fontSize={24} className="text-red-600" />,
    title: "Notification",
    desc: "Manage your notifications.",
    bgColor: "bg-red-100",
    path: "notification",
  },
  {
    icon: <MdOutlinePayment fontSize={24} className="text-[#9F616A]" />,
    title: "Coupon",
    desc: "Apply coupon code.",
    bgColor: "bg-[#FFF0F2]",
    path: "coupons",
  },
  // {
  //   icon: <MdOutlinePerson2 fontSize={24} className="text-yellow-600" />,
  //   title: "Agent Code",
  //   desc: "View your agent code.",
  //   bgColor: "bg-yellow-100",
  //   path: "agent_code",
  // },
  {
    icon: <MdStarBorderPurple500 fontSize={24} className="text-pink-600" />,
    title: "Rate Us",
    desc: "Share your experience with the app.",
    bgColor: "bg-pink-100",
    path: "rate_Us",
  },
  {
    icon: <FaGear fontSize={24} className="text-gray-600" />,
    title: "Settings",
    desc: "Manage your account settings.",
    bgColor: "bg-gray-100",
    path: "settings",
  },
  {
    icon: <PiHeadCircuit fontSize={24} className="text-yellow-600" />,
    title: "Legal Info",
    desc: "View terms and conditions.",
    bgColor: "bg-yellow-100",
    path: "legal_info",
  },
  {
    icon: <CiUser fontSize={24} className="text-gray-600" />,
    title: "About",
    desc: "Learn more about us.",
    bgColor: "bg-gray-100",
    path: "/about",
  },
  {
    icon: <RiLogoutBoxLine fontSize={24} className="text-rose-600" />,
    title: "Logout",
    desc: "Sign out of your account.",
    bgColor: "bg-rose-100",
    onClick: "logout",
  },
];



function ProfileSidebar() {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState({});

  const toggleSidebar = () => setIsOpen(!isOpen);


  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await USER_URL.get("/accounts/profile-update/");
        console.log(response);
        setUser(response.data.Data[0]);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUser();
  }, []);

  return (
    <div>
      {/* <button className={`p-3 lg:hidden ${isOpen ? "hidden" : "block"}`} onClick={toggleSidebar} >
              <FaBars fontSize={24} />
            </button> */}
      <div className="flex-col items-center justify-center text-center">
        {/* <div className="flex justify-center">
  
          <img
            src={`${process.env.PUBLIC_URL}/images/profile/Ellipse.png`}
            alt="Profile"
            className="h-24 w-24 space-y-10 rounded-[2px]"
          />
        </div> */}
        
        <p className="mt-4 text-lg font-semibold">Hey {user?.first_name || ""}</p>
        <p className="text-sm text-gray-600">{user?.email || ""}</p>
        <p className="text-sm text-gray-600">{user?.country || ""}</p>
        {!user?.is_profile_completed ? (
          <div className="flex items-center gap-2 text-[9px] sm:text-xs justify-center md:justify-between p-2 rounded-md">
            <p>Complete your profile</p>
            <Link to="/profile/edit_profile" className="text-green-500 hover:text-green-600 cursor-pointer transition duration-500 ease-in-out ">Click here</Link>
          </div>
        ) : (
          <></>
        )}
      </div>

      <nav className="mt-4">
        {profilemenu.map((item, index) => (
          <div key={index} className="flex items-center p-2">
            {/* Check if the item has an onClick function for logout */}
            {item.title === "Logout" ? (
              <button
                onClick={logout}
                className="flex w-full items-center"
              >
                <span className={`rounded-full border p-2 ${item.bgColor}`}>
                  {item.icon}
                </span>
                <div className="ml-3 flex flex-col md:block text-start">
                  <p className="text-[14px] font-semibold text-[#606060] hover:text-black">{item.title}</p>
                  {item.desc && (
                    <p className="text-[10px] font-normal text-[#606060]">
                      {item.desc}
                    </p>
                  )}
                </div>
              </button>
            ) : (
              <NavLink to={item.path || "#"} className="flex w-full items-center">
                <span className={`rounded-full border p-2 ${item.bgColor}`}>
                  {item.icon}
                </span>
                <div className="ml-3 flex flex-col md:block">
                  <p
                    className={`text-[14px] font-semibold ${location.pathname.endsWith(item.path)
                      ? "text-[14px] font-semibold text-black"
                      : "text-[14px] font-semibold text-gray-500 "
                      }`}
                  >
                    {item.title}
                  </p>
                  {item.desc && (
                    <p className="text-[10px] font-normal text-[#606060]">
                      {item.desc}
                    </p>
                  )}
                </div>
              </NavLink>
            )}
            <IoIosArrowForward className="ml-auto" />
          </div>
        ))}
      </nav>
    </div>
  );
}

export default ProfileSidebar;